import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;
    apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {

        if (!sessionStorage.getItem('authUser')) {
            return null;
        }
        return JSON.parse(sessionStorage.getItem('authUser'));
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        const url = this.apiUrl + '/auth/admin/login-password';
        return this.http.post<any>(url, { email, password }).toPromise().then((response: any) => {
            // expected response: { access_token: '', user: { id, email, name, role } }
            const apiUser = response && response.user ? response.user : null;
            if (apiUser) {
                apiUser.token = response.access_token || response.token || null;
                // keep compatibility with other parts that read from sessionStorage via authUtils
                sessionStorage.setItem('authUser', JSON.stringify(apiUser));
            }
            return apiUser;
        }).catch((err) => {
            return Promise.reject(err);
        });
    }

    sendOtp(email: string) {
        console.log("Sending OTP to email:", email);
        return this.http.post<any>(`${this.apiUrl}/auth/send-otp`, { email });
    }

    verifyOtp(email: string, otp: string) {
        const url = this.apiUrl + '/auth/admin/login-otp';
        return this.http.post<any>(url, { email, otp });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    sendMailToResetPassword(email: string) {
        return this.http.post(`${this.apiUrl}/auth/password-reset-request`, { email });
    }

    resetPassword(data: any) {
        return this.http.post(`${this.apiUrl}/auth/password-reset`, data);
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        sessionStorage.removeItem('authUser');
        // getFirebaseBackend().logout();
    }
}

